import React, { FC, useEffect } from 'react';
import { Audience, SecureRoute, useAuthState } from '@vis-auth/react';
import { EveFooter, EveRoutes, EveHeader } from '@ver-uds/e-verify';
import { Switch } from 'react-router-dom';
import ReactGA from 'react-ga4';
import SessionHandler from './components/SessionHandler';
import PrivateRoute from './components/PrivateRoute';
import EnrollmentPage from './pages/Enrollment/Enrollment';
import { useEnvironment } from './context/Environment/EnvironmentContext';
import { useToggles } from './context/Toggles/TogglesContext';

const OriginRedirect = ({ path }: { path: string }): null => {
  useEffect(() => {
    window.location.assign(path);
  });
  return null;
};

const EnrollmentRoute: FC = () => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
  }, []);

  const { SELF_TEST_LINK_ENABLED } = useEnvironment();
  const { audience } = useAuthState();
  const isDashboardJWT = audience === Audience.everifyEmail;

  const toggles = useToggles();
  const isMfaEnvironment = toggles?.get('MFA_USER_CREATION') === 'on';

  return (
    <>
      {isDashboardJWT ? (
        <SecureRoute path="/">
          <OriginRedirect path={EveRoutes.DASHBOARD} />
        </SecureRoute>
      ) : (
        <Switch>
          {/* Enrollment Routes for OTC validated MFA Enrollment */}
          {isMfaEnvironment && (
            <PrivateRoute exact path={EveRoutes.ACCOUNT_ENROLL_NEW} isOTCAuth>
              <SessionHandler />
              <EveHeader showSelfTestLink={SELF_TEST_LINK_ENABLED || false} hideNavItems hideUserMenu />
              <EnrollmentPage />
              <div className="margin-top-auto">
                <EveFooter />
              </div>
            </PrivateRoute>
          )}
        </Switch>
      )}
    </>
  );
};

export default EnrollmentRoute;
